import {useSelector} from 'react-redux'
import {getCurrencyCode} from 'modules/meta/selectors'
import {getSearchBoxValues} from 'modules/searchBox/selectors'

import {selectUserId} from '@vio/core/src/auth/modules/selectors'
import {selectPriceWatchEntry} from '@vio/shared/src/priceWatch/slice/selectors'
import {PriceWatchMetric} from '@vio/shared/src/priceWatch/types'

import type {ContentHotel, Hotel} from '@findhotel/sapi'

/**
 * Reads `usePriceWatch`'s `isPriceWatchOn` off the cache without subscribing to the
 * trackings query, so the prompt never triggers a fetch of its own.
 */
export const useIsPriceWatchOn = (
  hotel: Hotel | ContentHotel | undefined
): boolean => {
  const {checkIn, checkOut, rooms} = useSelector(getSearchBoxValues)
  const currency = useSelector(getCurrencyCode)
  const userId = useSelector(selectUserId)

  const priceWatchEntry = useSelector(
    selectPriceWatchEntry({
      checkIn,
      checkOut,
      rooms,
      hotelId: hotel?.objectID ?? '',
      currency,
      userId
    })
  )

  return (
    Boolean(priceWatchEntry?.priceWatchId) &&
    priceWatchEntry?.metric !== PriceWatchMetric.Paused
  )
}
